// src/components/ProtectedRoute.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'; // Import Navigate for redirection and Outlet for nested routes
import { useAuth } from './AuthContext'; // Import the custom hook to access auth state

const ProtectedRoute = () => {
  // Get the current user and loading status from the authentication context
  const { currentUser, isLoading } = useAuth();

  // If the authentication state is still loading, show a loading message/spinner
  if (isLoading) {
    return <div>Loading authentication 2...</div>; // You can replace this with a more elaborate loading spinner
  }

  // If there is a currentUser (meaning the user is logged in), render the nested routes (Outlet)
  // Otherwise, if no currentUser (user is not logged in), redirect them to the /login page
  // 'replace' prop ensures the navigation replaces the current entry in the history stack,
  // preventing users from simply hitting the back button to bypass the login.
  return currentUser ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
